// extracted by mini-css-extract-plugin
export default {"page":"iY-z","cartModal":"jY-z","checkout":"kY-z","placeholder":"lY-z","account":"mY-z"};